import { render } from "./WeekPicks.vue?vue&type=template&id=af8c9b9a"
import script from "./WeekPicks.vue?vue&type=script&lang=ts"
export * from "./WeekPicks.vue?vue&type=script&lang=ts"
script.render = render

export default script